import { Produtividade } from '../../kpis/adapters';

/** Tabs do widget de produtividade dos representantes */
export enum RepresentanteProdutividadeWidgetTabs {
    GERAL = 'geral',
    AQUISICAO = 'aquisicao'
}

/** State do widget de produtividade dos representantes */
export interface RepresentanteProdutividadeWidgetState {
    /** Dados do widget */
    data: Produtividade;
    /** Tab ativa */
    activeTab: RepresentanteProdutividadeWidgetTabs
}
